import React, {useEffect, useRef, useState} from 'react';
import styles from './index.module.less';
import {
  Button,
  Callout,
  Card,
  Classes,
  Collapse,
  Colors, Divider,
  Elevation, HTMLSelect,
  Icon,
  Intent,
  ProgressBar
} from "@blueprintjs/core";
import { LineChart, Line, XAxis, Tooltip } from 'recharts';
import CalendarHeatmap from "react-calendar-heatmap";
import "react-calendar-heatmap/dist/styles.css";
import classes from 'classnames';
import useCourseEntry from "../../components/useCourseEntry";
import { useHistory } from 'react-router-dom';
import dayjs from "dayjs";
import {useSelector} from "react-redux";
import Avatar from 'react-avatar';
import Tour from 'reactour';
import tourSteps from '../../utils/tour-steps';
import DocumentTitle from 'react-document-title';
// import useBindPhoneNumber from "../../components/useBindPhoneNumber";

const Home = () => {
  const userInfo = useSelector(state => state.userInfo);
  // const { renderBindDialog } = useBindPhoneNumber();
  const history = useHistory();
  const expended = useRef(false);
  const [showTour, setShowTour] = useState(false);
  const { catalogs, handleCollapseCatalog, learnInfo, courseInfos, handleCourseChange, activeIndexCourseIndex } = useCourseEntry();
  useEffect(() => {
    const showed = window.localStorage.getItem('home-tour-showed');
    if (!showed) {
      setShowTour(true);
    }
  }, []);
  useEffect(() => {
    if (expended.current === true) {
      return;
    }
    if (courseInfos.length === 0) {
      return;
    }
    if (catalogs.length === 0) {
      return;
    }
    expended.current = true;
    let index = 0;
    catalogs.forEach((part, i) => {
      (part.chapters || []).forEach(chapter => {
        if (chapter.id === courseInfos[activeIndexCourseIndex].progress.chapterId) {
          index = i;
        }
      })
    });
    handleCollapseCatalog(index);
  }, [catalogs, courseInfos, activeIndexCourseIndex]);

  const handleTourClosed = () => {
    window.localStorage.setItem('home-tour-showed', '1');
    setShowTour(false);
  };

  const renderLessonIcon = (part, lesson) => {
    if (lesson.permission === 'can_not_learn' || part.permission === 'can_not_learn') {
      return (
        <Icon iconSize={18} icon='lock' color={Colors.GRAY5} />
      );
    }
    if (lesson.status === 'done') {
      return (
        <Icon iconSize={18} icon='tick-circle' color={Colors.GREEN5} />
      )
    }
    if (lesson.status === 'doing') {
      return (
        <Icon iconSize={18} icon='tick-circle' color={Colors.ORANGE5} />
      )
    }
    return (
      <Icon iconSize={18} icon='tick-circle' color={Colors.GRAY5} />
    );
  };
  const renderChapterIcon = (index, expand = false, permission) => {
    if (permission === 'can_not_learn') {
      return (
        <Icon className={styles['header-icon']}  iconSize={20} icon='lock' />
      )
    }
    return (
      <Icon className={styles['header-icon']} onClick={() => handleCollapseCatalog(index)} iconSize={20} icon={expand ? 'chevron-down' : 'chevron-right'} />
    )
  };

  const handleRedirectToLesson = (part, chapter, lesson) => {
    if (part.permission === 'can_not_learn') {
      return;
    }
    if (lesson.permission === 'can_not_learn') {
      return;
    }
    history.push(`/learn/${chapter.title}/${chapter.id}/${lesson.id}`);
  };

  const renderPartSubtitle = (part) => {
    if (part.unlockDate) {
      return (
        <div className={classes(Classes.UI_TEXT, Classes.TEXT_MUTED)} style={{ color: Colors.RED5 }}>解锁时间：{part.unlockDate}</div>
      )
    }
    const partProgress = part.chapters.reduce((unionLessons, chapter) => unionLessons.concat(chapter.lessons), []).reduce((result, lesson) => {
      if (lesson.status === 'done') {
        result[0] += 1;
      }
      result[1] += 1;
      return result;
    }, [0, 0]);
    return (
      <div className={classes(Classes.UI_TEXT, Classes.TEXT_MUTED)}>本章进度：{partProgress[0]}/{partProgress[1]}</div>
    );
  };

  const renderCourseSelector = () => {
    return (
      <HTMLSelect value={activeIndexCourseIndex} onChange={(e) => handleCourseChange(e.target.value)}>
        {courseInfos.map((courseInfo, index) => (
          <option key={courseInfo.baseInfo.uid} value={index}>{courseInfo.baseInfo.name}</option>
        ))}
      </HTMLSelect>
    );
  };

  const renderCourseProgress = () => {
    if (courseInfos.length === 0) {
      return null;
    }
    const courseProgress = courseInfos[activeIndexCourseIndex].progress;
    return (
      <Card elevation={Elevation.ZERO} className={classes('progress', styles['progress-card'])}>
        <div className={styles.header}>
          {/*<div>{renderCourseSelector()}</div>*/}
          <h3 className={Classes.HEADING}>{getDocumentTitle()}</h3>
        </div>
        <ProgressBar className={styles['progress-bar']} animate intent={Intent.SUCCESS} value={courseProgress.value} />
        <div className={styles.actions}>
          <div>
            <h4 className={Classes.HEADING}>第{courseProgress.chapterNo}章 第{courseProgress.lessonNo}节 {courseProgress.title}</h4>
            <p className={Classes.UI_TEXT}>{courseProgress.subtitle}</p>
          </div>
          <div>
            <Button icon='console' intent={Intent.SUCCESS} onClick={() => history.push(`/learn/${courseProgress.title}/${courseProgress.chapterId}/${courseProgress.lessonId}`)}>立即开始学习</Button>
          </div>
        </div>
      </Card>
    )
  };

  const getDocumentTitle = () => {
    if (courseInfos.length === 0) {
      return '';
    }
    return courseInfos[activeIndexCourseIndex].baseInfo.name;
  };

  return (
    <DocumentTitle title={`${getDocumentTitle()} - Python for Fun`}>
      <div className={styles.home}>
        <div className={styles.nav}>
          <div className={styles['user-info']}>
            <Avatar className={styles.avatar} src={userInfo.avatar} name={userInfo.userName} size={48} />
            <div className={styles.content}>
              <h4 className={Classes.HEADING}>{userInfo.timeSlot}好，{userInfo.userName}</h4>
              <p className={classes(Classes.TEXT_MUTED, Classes.TEXT_SMALL)}>{userInfo.date} {userInfo.week}</p>
            </div>
          </div>
          <div className={classes('study-time', styles['study-time'], Classes.CODE_BLOCK, learnInfo.loading && Classes.SKELETON)}>
            <h5 className={classes(Classes.HEADING)}>你的总学习时长：{learnInfo.learnAllHours}小时</h5>
          </div>
          <div className={styles['select-course']}>
            <div className={styles.selector}>
              <h6 className={Classes.HEADING}>请选择课程：</h6>
              {renderCourseSelector()}
            </div>
          </div>
          <div className={classes('last-7-days', styles.charts, learnInfo.loading && Classes.SKELETON)}>
            <h6 className={Classes.HEADING}>最近7天学习时长</h6>
            <LineChart width={520} height={300} data={learnInfo.last7Days} margin={{top: 5, right: 30, left: 20, bottom: 5}}>
              <XAxis axisLine={{ stroke: '#ffffff' }} dataKey="name" tick={{ stroke: '#ffffff', strokeWidth: 0, fill: '#ffffff' }} tickLine={{ stroke: '#ffffff' }}/>
              <Tooltip separator='' labelStyle={{ display: 'none' }} formatter={(value) => [`${value}分钟`, '']} />
              <Line type="monotone" dataKey="minute" stroke="#FFB366" activeDot={{r: 8}}/>
            </LineChart>
          </div>
          <div className={classes('heatmap', styles.heatmap, learnInfo.loading && Classes.SKELETON)}>
            <CalendarHeatmap
              startDate={dayjs().subtract(200, 'day')}
              endDate={new Date()}
              values={learnInfo.heatmapData}
              classForValue={value => {
                if (!value) {
                  return 'color-empty';
                }
                if (value.count / 4 > 6) {
                  return 'color-scale-6';
                }
                return `color-scale-${Math.ceil(value.count / 4)}`;
              }}
              tooltipDataAttrs={(value) => {
                if (value.count > 0) {
                  return {
                    "data-tip": `${dayjs(value.date).format('YYYY年MM月DD')}: ${value.count}节课程`
                  };
                }
              }}
              monthLabels={["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]}
            />
            <h6 className={Classes.HEADING}>连续学习最长天数：{learnInfo.severalLearnDays}</h6>
          </div>
        </div>
        <div className={styles.main}>
          {/*<div className={styles.header}>*/}
          {/*  <h1 className={Classes.HEADING}>{baseInfo.name}</h1>*/}
          {/*  <div className={styles.action}>*/}
          {/*    <Button icon='form' intent={Intent.PRIMARY}>切换课程</Button>*/}
          {/*  </div>*/}
          {/*</div>*/}
          {renderCourseProgress()}
          <Divider className={styles.divider} />
          {catalogs.map((part, index) => (
            <Callout key={part.id} icon={renderChapterIcon(index, part.expand, part.permission)} className={classes(index === 0 && 'first-can-learn-chapter', styles.part, part.permission === 'can_not_learn' && styles.disabled)}>
              <div className={styles['part-title']}>
                <h3 className={classes(Classes.HEADING, styles.title)} onClick={() => handleCollapseCatalog(index)}>第{part.partNo}部分 {part.title}</h3>
                {renderPartSubtitle(part)}
              </div>
              <p className={classes(Classes.TEXT_MUTED, styles.desc)}>{part.desc}</p>
              <Collapse isOpen={part.expand}>
                {(part.chapters || []).map(chapter => (
                  <div className={styles.chapter} key={chapter.id}>
                    <div className={styles.header}>
                      <Icon icon='grid-view' iconSize={20} />
                      <h4 className={classes(Classes.HEADING)} style={{ color: Colors.FOREST5 }}>LESSON： {chapter.title}</h4>
                    </div>
                    <div className={styles.body}>
                      {(chapter.lessons || []).map((lesson, i) => (
                        <div key={lesson.id} className={classes(index === 0 && i === 0 && 'first-lesson', index === 0 && i === 1 && 'second-lesson', styles['article-title'], lesson.permission === 'can_not_learn' && styles.disabled)}>
                          {renderLessonIcon(part, lesson)}
                          <h6 onClick={() => handleRedirectToLesson(part, chapter, lesson)} className={Classes.HEADING}>{lesson.lessonNo}. {lesson.title}</h6>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </Collapse>
            </Callout>
          ))}
        </div>
        <Tour isOpen={showTour} steps={tourSteps.home} onRequestClose={handleTourClosed} />
        {/*{renderBindDialog()}*/}
      </div>
    </DocumentTitle>
  );
};

export default Home;
